import React from "react";
import {useDispatch, useSelector} from "react-redux";
import {
  editEntrantStatusAction, fetchEntrantTransferToOtherCollegeAction,
} from "../../../../../../store/pages/admission/actions";
import {Col, Modal, Row, Select, Typography} from "antd";
import {CloseOutlined} from "@ant-design/icons";
import {selectStore} from "../../../../../../store/selector";
import {Trans, useTranslation} from "react-i18next";

export const TransferModal = ({
                              visible,
                              setVisible,
                              initialVisibleState,
                              data
                            }:any) => {
  const dispatch = useDispatch();
  const [collegeToTransfer, setCollegeToTransfer] = React.useState<any>();
  const {admission: {collegeListToTransfer: collegeListToTransferState}} = useSelector(selectStore);

  const {t} = useTranslation(["educationOrders", "common"])

  const handleClose = () => {
    setVisible(initialVisibleState)
  }

  const handleOk = () => {
    //ok actions
    const requestData = {
      selected_speciality_id: data.selectedSpeciality.id,
      college_id: collegeToTransfer
    }

    dispatch(fetchEntrantTransferToOtherCollegeAction(requestData))

    setCollegeToTransfer(null)
    setVisible(initialVisibleState)
  }

  return (
    <Modal
      open={visible}
      title={t("educationOrders:entrantTransfer")}
      centered
      width={548}
      closable
      className="modal_container "
      closeIcon={<CloseOutlined style={{color: "#fff"}}/>}

      okText={t("educationOrders:doTransfer")}
      cancelText={t("common:cancel")}

      onOk={handleOk}
      onCancel={handleClose}
      rootClassName='modal-restore'
    >
      <Row>
        <Col span={24}>
          <Typography.Text>
            <Trans i18nKey="educationOrders:acceptModalText" values={{specialtyName: data && data.selectedSpeciality && data.selectedSpeciality.speciality && data.selectedSpeciality.speciality.caption}}>
              Абитуриент был уведомлен и дает свое согласие на перевод в другое учебное заведение на специальность <span
              className="speciality-name">{data && data.selectedSpeciality && data.selectedSpeciality.speciality && data.selectedSpeciality.speciality.caption}</span>
            </Trans>
          </Typography.Text>
        </Col>

        <Col span={24}>
          <Select value={collegeToTransfer} size="large" style={{marginTop: 10, width: 500}} disabled={!collegeListToTransferState.success} loading={collegeListToTransferState.loading}
                  onChange={(value) => setCollegeToTransfer(value)}>
            {collegeListToTransferState.data?.map((item: any) => (
              <Select.Option key={item.name + "-" + item.id} value={item.id}>{item.name}</Select.Option>
            ))}
          </Select>
        </Col>
      </Row>
    </Modal>
  );
}